"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLES = void 0;
const module_roles_1 = require("./module-roles");
const modules_1 = require("./modules");
exports.ROLES = {
    [modules_1.Modules.FILE_MANAGEMENT]: Object.values(module_roles_1.FILE_MANAGEMENT_ROLES),
    [modules_1.Modules.HR]: Object.values(module_roles_1.HR_ROLES),
    [modules_1.Modules.INVENTORY]: Object.values(module_roles_1.INVENTORY_ROLES),
    [modules_1.Modules.PARTNERS]: Object.values(module_roles_1.PARTNERS_ROLES),
    [modules_1.Modules.PRODUCT_IMPLEMENTATION]: Object.values(module_roles_1.PRODUCT_IMPLEMENTATION_ROLES),
    [modules_1.Modules.PRODUCTION]: Object.values(module_roles_1.PRODUCTION_ROLES),
    [modules_1.Modules.PRODUCTS]: Object.values(module_roles_1.PRODUCTS_ROLES),
    [modules_1.Modules.REQUEST_FOR_QUOTE]: Object.values(module_roles_1.RFQ_ROLES),
    [modules_1.Modules.SALES_ORDER]: Object.values(module_roles_1.SALES_ORDER_ROLES),
    [modules_1.Modules.SHIPMENT]: Object.values(module_roles_1.SHIPMENT_ROLES),
    [modules_1.Modules.USER_MANAGEMENT]: Object.values(module_roles_1.USER_MANAGEMENT_ROLES),
    [modules_1.Modules.SETUP]: Object.values(module_roles_1.SETUP_ROLES),
    [modules_1.Modules.TRAVERSE_FRONTEND]: Object.values(module_roles_1.TRAVERSE_FRONTEND_ROLES),
};
//# sourceMappingURL=roles.js.map